import { render, staticRenderFns } from "./BeneficiaryImport.vue?vue&type=template&id=2cb8286c"
import script from "./BeneficiaryImport.vue?vue&type=script&lang=js"
export * from "./BeneficiaryImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports